<div [dir]="direction">
  <app-loading-spinner [isLoading]="isLoading"></app-loading-spinner>
  <form
    class="needs-validation payment-form"
    novalidate
    [formGroup]="paymentForm"
    (ngSubmit)="submit()"
    enctype="multipart/form-data"
  >
    <h2 mat-dialog-title class="mb-2">Generar Pago</h2>
    <!-- Mostrar grupo cuando es pago parcial -->
    <div *ngIf="isPartial && ((groupName || '').trim().length > 0)" class="partial-group-banner">
      <span class="label">Pago parcial — Grupo:</span>
      <span class="group-name">{{ groupName }}</span>
    </div>
    <mat-dialog-content class="mat-typography payment-content max-h-[70vh] overflow-y-auto">
      <div class="grid grid-cols-12">
        <div class="col-span-12">
          <div class="rounded-xl border border-slate-200 bg-white shadow-sm">
            <div class="p-3 sm:p-4">
              <div class="grid grid-cols-12">
                <div class="col-span-12 mb-2">
                  <h6 class="mb-2 flex justify-between items-center text-xs uppercase tracking-wide text-slate-600 font-semibold">
                    <span class="text-slate-900">Resumen del pedido</span>
                    <span class="inline-flex items-center justify-center rounded-md bg-indigo-500 text-white text-xs px-2 h-5">{{orderList.length}}</span>
                  </h6>
                  <ul class="payment-list space-y-2">
                    @for(item of orderList; track item){ @if(item.description
                    !== 'EXAMPLECODE'){
                    <li class="py-2" [class.canceled]="((item.itemStatusSlug || '').toLowerCase() === 'canceled')">
                      <div class="flex justify-between items-start gap-2">
                        <div class="flex-1">
                          <div class="item-name font-semibold">{{ item.name }}</div>
                          <div class="item-desc text-muted text-xs" *ngIf="(item.description || '').trim().length">
                            {{ item.description }}
                          </div>
                          <div class="option-list" *ngIf="getItemOptionBreakdown(item).length">
                            <div class="option-list__item flex justify-between" *ngFor="let opt of getItemOptionBreakdown(item)">
                              <span class="option-name">{{ opt.count }} × {{ opt.name }}</span>
                              <span class="option-calc text-nowrap">
                                <span class="qty-unit">$ {{ opt.unitPrice | number:'1.0-0' }}</span>
                                <span class="equals">=</span>
                                <span class="subtotal fw-semibold">$ {{ opt.subtotal | number:'1.0-0' }}</span>
                              </span>
                            </div>
                          </div>
                          <!-- Cuando NO hay opciones, mostrar el cálculo debajo del nombre, alineado a la derecha -->
                          <div class="calc-row w-full text-right flex items-baseline gap-1" *ngIf="!getItemOptionBreakdown(item).length">
                            <span class="qty-unit whitespace-nowrap">{{ getItemCalc(item).qty }} x ${{ getItemCalc(item).unitPrice | number:'1.0-0' }}</span>
                            <span class="equals mx-1">=</span>
                            <span class="subtotal whitespace-nowrap font-semibold">${{ getItemCalc(item).subtotal | number:'1.0-0' }}</span>
                          </div>
                        </div>
                        <!-- When options exist, do not show the aggregated subtotal; only list per-option rows -->
                      </div>
                    </li>
                    } @else {
                    <li
                      class="list-group-item d-flex justify-content-between active"
                    >
                      <div class="text-white">
                        <h6 class="my-0 text-white">{{ item.name }}</h6>
                        <small>{{ item.description }} </small>
                      </div>
                      <span class="text-white">-$5</span>
                    </li>
                    } }
                    <!-- Descuento (si existe) -->
                    <li class="flex justify-between py-1" *ngIf="discountAmount && discountAmount > 0">
                      <span class="fw-medium">Descuento{{ discountNote ? ' (' + discountNote + ')' : '' }}</span>
                      <strong class="text-danger">- ${{ discountAmount | number:'1.0-0' }}</strong>
                    </li>
                    <li class="flex justify-between py-1 total-print-row">
                      <span class="fw-medium">Total a imprimir</span>
                      <strong class="text-black">${{ totalAmount | number:'1.0-0' }}</strong>
                    </li>
                    <!-- Definición de propina en la misma fila -->
<div class="flex items-center justify-between my-0 tip-inline section-separator text-xs">
                      <div class="flex items-center gap-2">
                        <ui-checkbox id="tip-top" formControlName="tip">
                          <span class="form-check-label mb-0">Propina ({{ tipPercent }}%)</span>
                        </ui-checkbox>
                      </div>
                      <div class="flex items-center gap-2">
                        <span class="text-slate-500">$</span>
                        <input
                          type="number"
  class="form-control tip-input tip-input-bordered rounded-lg border border-slate-200 bg-slate-50 px-2 h-8 text-xs"
                          style="max-width: 120px;"
                          formControlName="tipAmount"
                          (input)="onTipAmountInput()"
                        />
                        <small class="text-slate-500">({{ tipPercent }}%)</small>
                      </div>
                    </div>
                    <!-- Resumen final con propina -->
                    <div class="mt-0 total-row section-separator">
                      <div class="w-full">
                        <div class="flex justify-between items-center">
                          <span class="fw-medium">Total final</span>
                          <strong>${{ totalWithTip | number:'1.0-0' }}</strong>
                        </div>
                      </div>
                    </div>
                  </ul>
                  <h5 class="mb-0 section-separator text-xs uppercase tracking-wide text-slate-600">Método de pago</h5>
                  <div class="form-validation space-y-2">
                    <!-- TD/TC card + inline inputs -->
                    <div class="payment-card w-full rounded-lg border border-slate-200 bg-white shadow-sm px-3 py-2 text-sm">
                      <div class="grid grid-cols-12 items-center gap-2 w-full">
                        <div class="col-span-3">
                          <ui-checkbox
                            id="td/tc"
                            formControlName="tcTd"
                            (checkedChange)="toggleTcTd({ target: { checked: $event } })"
                          >
                            <span class="form-check-label whitespace-nowrap">TD / TC</span>
                          </ui-checkbox>
                        </div>
                        <div class="col-span-9" *ngIf="paymentForm.get('tcTd')?.value">
                          <div class="flex items-center justify-end gap-2 w-full">
                            <input
                              type="number"
                              class="form-control rounded-xl border border-slate-200 bg-slate-50 px-2 h-8 text-xs w-24 sm:w-32 ml-auto"
                              name="tcTdAmount"
                              formControlName="tcTdAmount"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Efectivo card + inline inputs -->
                    <div class="payment-card w-full rounded-lg border border-slate-200 bg-white shadow-sm px-3 py-2 text-sm">
                      <div class="grid grid-cols-12 items-center gap-2 w-full">
                        <div class="col-span-3">
                          <ui-checkbox
                            id="cash"
                            formControlName="cash"
                            (checkedChange)="toggleEfectivo({ target: { checked: $event } })"
                          >
                            <span class="form-check-label whitespace-nowrap">Efectivo</span>
                          </ui-checkbox>
                        </div>
                        <div class="col-span-9" *ngIf="paymentForm.get('cash')?.value">
                          <div class="flex items-center justify-end gap-2 w-full">
                            <input
                              type="number"
                              class="form-control rounded-xl border border-slate-200 bg-slate-50 px-2 h-8 text-xs w-24 sm:w-32 ml-auto"
                              placeholder="Enter"
                              name="cashAmount"
                              formControlName="cashAmount"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Convenio card + inline inputs -->
                    <div class="payment-card w-full rounded-lg border border-slate-200 bg-white shadow-sm px-3 py-2 text-sm">
                      <div class="grid grid-cols-12 items-center gap-2 w-full">
                        <div class="col-span-3">
                          <ui-checkbox
                            id="agreement"
                            formControlName="agreement"
                            (checkedChange)="toggleAgreement({ target: { checked: $event } })"
                          >
                            <span class="form-check-label whitespace-nowrap">Convenio</span>
                          </ui-checkbox>
                        </div>
                        <div class="col-span-9" *ngIf="paymentForm.get('agreement')?.value">
                          <div class="flex items-center justify-end gap-2 w-full">
                            <input
                              type="number"
                              class="form-control rounded-xl border border-slate-200 bg-slate-50 px-2 h-8 text-xs w-24 sm:w-32 ml-auto"
                              name="agreementAmount"
                              formControlName="agreementAmount"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Transferencia card + inline inputs -->
                    <div class="payment-card w-full rounded-lg border border-slate-200 bg-white shadow-sm px-3 py-2 text-sm">
                      <div class="grid grid-cols-12 items-center gap-2 w-full">
                        <div class="col-span-3">
                          <ui-checkbox
                            id="transfer"
                            formControlName="transfer"
                            (checkedChange)="toggleTransfer({ target: { checked: $event } })"
                          >
                            <span class="form-check-label whitespace-nowrap">Transferencia</span>
                          </ui-checkbox>
                        </div>
                        <div class="col-span-9" *ngIf="paymentForm.get('transfer')?.value">
                          <div class="flex items-center justify-end gap-2 w-full">
                            <input
                              type="number"
                              class="form-control rounded-xl border border-slate-200 bg-slate-50 px-2 h-8 text-xs w-24 sm:w-32 ml-auto"
                              name="transferAmount"
                              formControlName="transferAmount"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="payment-actions">
      <button type="button" class="btn btn-outline-secondary me-2" (click)="dialogRef.close()">Cancelar</button>
      <button type="submit" class="btn btn-primary rounded-xl px-6 py-2 font-semibold" [disabled]="!checkPayment()">Pagar</button>
    </mat-dialog-actions>
  </form>
</div>
